module.exports = __webpack_public_path__ + "static/plan-fcf1e02ebdb6b9e13d1ae55d70d7a656.png";